// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ProductionCountryVO')
export class ProductionCountryVO {

  @JsonProperty('iso2', 'string')
  public iso2: string;

  @JsonProperty('name', 'string')
  public name: string;
}
